"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var namespace_1 = __importDefault(require("../namespace"));
namespace_1.default.namespace.extend('setup.params', function () {
    this.load = function (deferred) {
        var defObj = jquery_1.default.Deferred();
        var loader = this.getLoader();
        jquery_1.default.when(defObj).then(function () {
            deferred.resolve();
        });
        var changedOptions = {
            url: this.getUrl(),
            deferred: defObj
        };
        loader.setOptions(changedOptions);
        loader.load();
    };
    this.getLoader = function () {
        return new namespace_1.default.loader.scripts();
    };
    this.getUrl = function () {
        var scriptArr = (0, jquery_1.default)('script');
        var scriptUrl = '';
        // matches the (minified) JS filename, e.g. apa.spine.3.0.min.js, apa.spine.3.0.js
        var regexp = /(\bapa\.)?spine\.[0-9.]+\.(min\.)?js\b/;
        Object.keys(scriptArr).forEach(function (item) {
            if (scriptArr[item] && scriptArr[item].src && scriptArr[item].src.match(regexp)) {
                scriptUrl = scriptArr[item].src.replace(regexp, 'client.spine.params.js');
                return false;
            }
        });
        return scriptUrl + '?cb=' + new Date().getMinutes();
    };
});
